export default [
  {
    title: '采购项目公告',
    code: 'a1',
    children: [
      {
        title: '公开招标公告',
        code: '3001'
      },
      {
        title: '竞争性谈判公告',
        code: '3002'
      },
      {
        title: '询价公告',
        code: '3003'
      },
      {
        title: '邀请招标资格预审公告',
        code: '3008'
      },
      {
        title: '竞争性磋商公告',
        code: '3011'
      },
      {
        title: '公开招标资格预审公告',
        code: '2001'
      },
      {
        title: '其他采购项目公告',
        code: '2002'
      }
    ]
  },
  {
    title: '意见征询',
    code: 'a2',
    children: [
      {
        title: '采购文件需求公示',
        code: '3014'
      },
      {
        title: '允许采购进口产品公示',
        code: '3013'
      },
      {
        title: '单一来源公示',
        code: '3012'
      },
      {
        title: '其他意见征询公告',
        code: '1001'
      }
    ]
  },
  {
    title: '更正公告',
    code: 'a3',
    children: [
      {
        title: '更正公告',
        code: '3005'
      },
      {
        title: '澄清(修改)公告',
        code: '3006'
      },
      {
        title: '中止(暂停)公告',
        code: '3018'
      },
      {
        title: '其他更正公告',
        code: '3019'
      }
    ]
  },
  {
    title: '采购结果公告',
    code: 'a4',
    children: [
      {
        title: '中标（成交）结果公告',
        code: '3004'
      },
      {
        title: '废标公告',
        code: '3007'
      },
      {
        title: '邀请招标资格入围公告',
        code: '3009'
      },
      {
        title: '终止公告',
        code: '3015'
      },
      {
        title: '采购结果变更公告',
        code: '3017'
      },
      {
        title: '公开招标资格入围公告',
        code: '4004'
      },
      {
        title: '其他采购结果公告',
        code: '4007'
      }
    ]
  },
  {
    title: '采购合同公告',
    code: 'a5',
    children: [
      {
        title: '采购合同公告',
        code: '3010'
      },
      {
        title: '其他采购合同公告',
        code: '5002'
      }
    ]
  },
  {
    title: '履约验收公告',
    code: 'a6',
    children: [
      {
        title: '履约验收公告（服务类）',
        code: '3016'
      },
      {
        title: '其他履约验收公告',
        code: '6003'
      }
    ]
  },
  {
    title: '电子卖场公告',
    code: 'a7',
    children: [
      {
        title: '协议定点项目招标公告',
        code: '4001'
      },
      {
        title: '协议定点项目中标公告',
        code: '4002'
      },
      {
        title: '协议定点项目更正公告',
        code: '4003'
      },
      {
        title: '电子卖场合同公告',
        code: '1995'
      },
      {
        title: '电子卖场终止公告',
        code: '1995'
      },
      {
        title: '在线询价公告',
        code: '8011'
      },
      {
        title: '反向竞价公告',
        code: '8010'
      },
      {
        title: '协议定点项目采购结果更正公告',
        code: '8006'
      },
      {
        title: '电子卖场中止（暂停）公告',
        code: '1997'
      },
      {
        title: '在线询价结果公告',
        code: '8009'
      },
      {
        title: '定点服务结果公告',
        code: '9002'
      },
      {
        title: '反向竞价结果公告',
        code: '8008'
      },
      {
        title: '其他电子卖场采购公告',
        code: '9003'
      }
    ]
  },
  {
    title: '非政府采购公告',
    code: 'a8',
    children: [
      {
        title: '公款竞争性存放意见征询',
        code: '10001'
      },
      {
        title: '公款竞争性存放招标公告',
        code: '10002'
      },
      {
        title: '公款竞争性存放更正公告',
        code: '10003'
      },
      {
        title: '公款竞争性存放结果公告',
        code: '10004'
      },
      {
        title: '公款竞争性存放合同公告',
        code: '10005'
      },
      {
        title: '其他非政府采购项目意见征询',
        code: '10006'
      },
      {
        title: '其他非政府采购项目招标公告',
        code: '10007'
      },
      {
        title: '其他非政府采购项目更正公告',
        code: '10008'
      },
      {
        title: '其他非政府采购项目结果公告',
        code: '10009'
      },
      {
        title: '其他非政府采购项目合同公告',
        code: '10010'
      },
      {
        title: '国库现金管理招标公告',
        code: '10012'
      },
      {
        title: '国库现金管理中标公告',
        code: '10013'
      },
      {
        title: '国库现金管理更正公告',
        code: '10014'
      },
      {
        title: '其他非政府采购公告',
        code: '10011'
      }
    ]
  },
  {
    title: '政府采购监管公告',
    code: 'a9',
    children: [
      {
        title: '投诉处理信息公告',
        code: '7003'
      },
      {
        title: '行政处罚信息公告',
        code: '7004'
      },
      {
        title: '行政处理信息公告',
        code: '7005'
      },
      {
        title: '监督检查公告',
        code: '7006'
      },
      {
        title: '集中采购机构考核结果公告',
        code: '7007'
      },
      {
        title: '供应商、采购代理机构和评审专家的违法失信行为记录公告',
        code: '7008'
      },
      {
        title: '其他监管公告',
        code: '7009'
      }
    ]
  },
  {
    title: '地区',
    isDistrict: true,
    code: 'a10',
    children: [
      {
        title: '杭州市',
        code: '330199'
      },
      {
        title: '宁波市',
        code: '330299'
      },
      {
        title: '温州市',
        code: '330399'
      },
      {
        title: '嘉兴市',
        code: '330499'
      },
      {
        title: '湖州市',
        code: '330599'
      },
      {
        title: '绍兴市',
        code: '330699'
      },
      {
        title: '金华市',
        code: '330799'
      },
      {
        title: '衢州市',
        code: '330899'
      },
      {
        title: '舟山市',
        code: '330999'
      },
      {
        title: '台州市',
        code: '331099'
      },
      {
        title: '丽水市',
        code: '331199'
      },
      {
        title: '浙江省省本级',
        code: '339900'
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/utils/menu.js